import React from 'react';
import {HashRouter, Routes, Route} from "react-router-dom";
import Header from "./Header";
import Home from "../pages/Home/Home";

function Layout(props) {
    return (
        <HashRouter>
            <Header/>
            <Routes>
                <Route path="/" element={<Home/>} />
            </Routes>
        </HashRouter>
    );
}

export default Layout;